import { UserType } from "@/types/user.types";

export const PERMISSIONS = {
    // TR_SVC_CUSTOM_PASSENGERS_FIND: "TR_SVC_CUSTOM_PASSENGERS_FIND",
    // TR_SVC_CUSTOM_PASSENGERS_LIST_BY_DATE: "TR_SVC_CUSTOM_PASSENGERS_LIST_BY_DATE",
    // TR_SVC_CUSTOM_PASSENGERS_CREATE: "TR_SVC_CUSTOM_PASSENGERS_CREATE",
    // TR_SVC_CUSTOM_PASSENGERS_UPDATE: "TR_SVC_CUSTOM_PASSENGERS_UPDATE",
    // TR_SVC_CUSTOM_PASSENGERS_DELETE: "TR_SVC_CUSTOM_PASSENGERS_DELETE",

    TR_SVC_DRIVERS_ME: "TR_SVC_DRIVERS_ME",
    // TR_SVC_DRIVERS_FIND: "TR_SVC_DRIVERS_FIND",

    // TR_SVC_DRIVERS_TASKS_LIST: "TR_SVC_DRIVERS_TASKS_LIST",
    TR_SVC_DRIVERS_TASKS_LIST_BY_DATE: "TR_SVC_DRIVERS_TASKS_LIST_BY_DATE",
    // TR_SVC_DRIVERS_TASKS_FIND: "TR_SVC_DRIVERS_TASKS_FIND",
    TR_SVC_DRIVERS_CAMERAS: "TR_SVC_DRIVERS_CAMERAS",
    // TR_SVC_DRIVERS_REGISTER: "TR_SVC_DRIVERS_REGISTER",
    // TR_SVC_DRIVERS_ASSIGN: "TR_SVC_DRIVERS_ASSIGN",
    // TR_SVC_DRIVERS_QR_SCAN: "TR_SVC_DRIVERS_QR_SCAN",
    // TR_SVC_DRIVERS_SHIFT_START_END: "TR_SVC_DRIVERS_SHIFT_START_END",

    TR_SVC_MAP_ZONES_LIST: "TR_SVC_MAP_ZONES_LIST",
    TR_SVC_VEHICLES_LIST: "TR_SVC_VEHICLES_LIST",
    TR_SVC_VEHICLES_PAGE: "TR_SVC_VEHICLES_PAGE",
    // TR_SVC_NOTIFICATIONS_FIND: "TR_SVC_NOTIFICATIONS_FIND",
    // TR_SVC_NOTIFICATIONS_LIST: "TR_SVC_NOTIFICATIONS_LIST",
    // TR_SVC_NOTIFICATIONS_LIST_UNREAD: "TR_SVC_NOTIFICATIONS_LIST_UNREAD",
    // TR_SVC_NOTIFICATIONS_SUBSCRIBE: "TR_SVC_NOTIFICATIONS_SUBSCRIBE",
    // TR_SVC_NOTIFICATIONS_CREATE: "TR_SVC_NOTIFICATIONS_CREATE",
    // TR_SVC_NOTIFICATIONS_MARK_READ: "TR_SVC_NOTIFICATIONS_MARK_READ",

    // TR_SVC_PASSENGERS_CHANGE_STATE: "TR_SVC_PASSENGERS_CHANGE_STATE",

    // Drivers

    // Transport Manager permissions
    TR_SVC_PASSENGERS_LIST_BY_DATE: "TR_SVC_PASSENGERS_LIST_BY_DATE",
    TR_SVC_PASSENGERS_SET_DATA: "TR_SVC_PASSENGERS_SET_DATA", // Needs to be deprecated
    TR_SVC_DATA_GRID_SAVE: "TR_SVC_DATA_GRID_SAVE",
    TR_SVC_UPDATE_PASSENGER_COMPANIONS: "TR_SVC_UPDATE_PASSENGER_COMPANIONS",

    // Back office permissions
    TR_SVC_BACK_OFFICE_PASSENGERS_SET_DATA: "TR_SVC_BACK_OFFICE_PASSENGERS_SET_DATA",

    // Welcome team permissions
    TR_SVC_GET_TASKS_ARRIVALS: "TR_SVC_GET_TASKS_ARRIVALS",
    TR_SVC_WELCOME_TEAM_PASSENGERS_SET_DATA: "TR_SVC_WELCOME_TEAM_PASSENGERS_SET_DATA",
    TR_SVC_WELCOME_TEAM_PASSENGERS_GET_IST_DATA: "TR_SVC_WELCOME_TEAM_PASSENGERS_GET_IST_DATA",
    TR_SVC_WELCOME_TEAM_PASSENGERS_SET_IST_DATA: "TR_SVC_WELCOME_TEAM_PASSENGERS_SET_IST_DATA",
    TR_SVC_WELCOME_TEAM_PASSENGERS_GET_SAW_DATA: "TR_SVC_WELCOME_TEAM_PASSENGERS_GET_SAW_DATA",
    TR_SVC_WELCOME_TEAM_PASSENGERS_SET_SAW_DATA: "TR_SVC_WELCOME_TEAM_PASSENGERS_SET_SAW_DATA",

    // TR_SVC_PATIENTS_FIND: "TR_SVC_PATIENTS_FIND",

    // TR_SVC_TASKS_FIND: "TR_SVC_TASKS_FIND",
    // TR_SVC_TASKS_UPDATE: "TR_SVC_TASKS_UPDATE",
    // TR_SVC_TASKS_AUTO_ASSIGN: "TR_SVC_TASKS_AUTO_ASSIGN",
    // TR_SVC_TASKS_UNASSIGN: "TR_SVC_TASKS_UNASSIGN",
    // TR_SVC_TASKS_DELETE: "TR_SVC_TASKS_DELETE",
    TR_SVC_TASKS_LIST_BY_DATE: "TR_SVC_TASKS_LIST_BY_DATE",

    TR_SVC_TASKS_UETDS_REGISTER: "TR_SVC_TASKS_UETDS_REGISTER",
    TR_SVC_TASKS_UETDS_CANCEL: "TR_SVC_TASKS_UETDS_CANCEL",

    TR_SVC_MANAGE_DRIVERS: "TR_SVC_MANAGE_DRIVERS",

    // TR_SVC_MANAGE_SHIFT_DATA: "TR_SVC_MANAGE_SHIFT_DATA",

    // HR permissions for driver status
    TR_SVC_HR_LIST_DAILY_STATUS: "TR_SVC_HR_LIST_DAILY_STATUS",
    TR_SVC_HR_MANAGE_DAILY_STATUS: "TR_SVC_HR_MANAGE_DAILY_STATUS",

    // HOTEL Planning
    TR_SVC_HR_LIST_HOTEL_PLANNING: "TR_SVC_HR_LIST_HOTEL_PLANNING",

    // List-Edit Users
    TR_SVC_HR_LIST_USERS: "TR_SVC_HR_LIST_USERS",
    TR_SVC_HR_MANAGE_USERS: "TR_SVC_HR_MANAGE_USERS",
    TR_SVC_UPDATE_DRIVER_VEHICLE: "TR_SVC_UPDATE_DRIVER_VEHICLE",
};

export const PERMISSION_IDS: Record<UserType, string[]> = {
    [UserType.ADMIN]: ["68108ccf1c2323c99a390d0a"],
    [UserType.MANAGER]: ["66f6efa343cdce3317860b11"],
    [UserType.HR]: ["68108c921c2323c99a390cfc"],
    [UserType.DRIVER]: ["67211cc5f64e552e04ce5cb0"],
    [UserType.KLINIK]: ["66f6efa343cdce3317860b11"],
    [UserType.WELCOME_TEAM_OFFICER]: ["67c01f691d251dc175d71b23", "67c01f571d251dc175d71b1b"],
};
